import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div\n  {{did-insert this.register}}\n  {{will-destroy this.unregister}}\n  ...attributes\n>{{yield this.count}}</div>")